import React from 'react';
import PackerDeliveryOrderItems from './packerDeliveryOrderItems';
import OrderPackingStatusDisplay from '../../components/orderPackingStatus';

const PackerDeliveryOrderBatchOrder = ({
  order,
  orderItemsForPacking,
  isPacked,
  packedItemIds,
  addRefundOrderItems,
  refundOrderItems,
  removeRefundOrderItem,
  addPackedItem,
  removePackedItemFromIndex,
}) => {
  const orderItems = orderItemsForPacking || order.items;

  return (
    <div className="m-b-6">
      <h4 className={isPacked ? 'text-muted' : ''}>
        <span className="m-r-2">
          <input name="packed" type="checkbox" checked={isPacked} readOnly />
        </span>
        {order.marketplaceName}
      </h4>

      <OrderPackingStatusDisplay order={order} />

      <PackerDeliveryOrderItems
        orderItems={orderItems}
        order={order}
        addToRefunds={addRefundOrderItems}
        refundOrderItems={refundOrderItems}
        removeFromRefunds={removeRefundOrderItem}
        packedItemIds={packedItemIds}
        addPackedItem={addPackedItem}
        removePackedItemFromIndex={removePackedItemFromIndex}
      />
    </div>
  );
};

export default PackerDeliveryOrderBatchOrder;
